<template>
  <div>
    <h3 class="titulo titulo_medio texto_cor-cinza-60 u-margem-inferior-media">
      {{ ordem }}º Proponente
    </h3>

    <div class="linha-de-dados">
      <span class="item-de-dado item-de-dado_largo">
        <strong>Nome:</strong>
        <span>{{ proponente.Nome }}</span>
      </span>
    </div>
    <div class="linha-de-dados">
      <span class="item-de-dado">
        <strong>CPF:</strong>
        <span>{{ proponente.Cpf }}</span>
      </span>
      <span class="item-de-dado">
        <strong>Telefone:</strong>
        <span>{{ proponente.Telefone || "NÃO INFORMADO" }}</span>
      </span>
    </div>
    <div class="linha-de-dados">
      <span class="item-de-dado">
        <strong>Renda individual:</strong>
        <span>{{ proponente.Renda || "NÃO INFORMADO" }}</span>
      </span>
    </div>

    <div v-if="proponente.Conjuge" class="conjuge-do-proponente">
      <h4
        class="titulo titulo_pequeno texto_cor-cinza-60 u-margem-inferior-media"
      >
        CÔNJUGE ({{ ordem }}º PROPONENTE)
      </h4>

      <div class="linha-de-dados">
        <span class="item-de-dado item-de-dado_largo">
          <strong>Nome:</strong>
          <span>{{ proponente.Conjuge.Nome }}</span>
        </span>
      </div>
      <div class="linha-de-dados">
        <span class="item-de-dado">
          <strong>CPF:</strong>
          <span>{{ proponente.Conjuge.Cpf }}</span>
        </span>
        <span class="item-de-dado">
          <strong>Telefone:</strong>
          <span>{{ proponente.Conjuge.Telefone || "NÃO INFORMADO" }}</span>
        </span>
      </div>
      <div class="linha-de-dados">
        <span class="item-de-dado">
          <strong>Renda individual:</strong>
          <span>{{ proponente.Conjuge.Renda || "NÃO INFORMADO" }}</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "proponente-item",
  props: {
    proponente: { type: Object, required: true },
    ordem: { type: Number, required: true },
  },
};
</script>



// WEBPACK FOOTER //
// ProponenteItem.vue?13076508